import React from 'react'
import logo from '../../image/m.png'
import classes from './header.module.css'
import {NavLink} from 'react-router-dom'
import HeadPhone from '../headPhone/HeadPhone'
import Form from '../../pages/contact/Form'
import FormDialog from '../../pages/contact/FormDialog';

function Header() {
  const [resize, setResize] = React.useState(() => window.innerWidth>530)
  const [open, setOpen] = React.useState(false)
  const [openphone, setOpenPhone] = React.useState(false)

  const [forphone, setForPhone] = React.useState(window.innerWidth)

  React.useEffect(() => {
    window.addEventListener("resize", function() {
      setForPhone(window.innerWidth)
      setResize(window.innerWidth>530)
    })
}, [])

const handleMenuPhone = () =>{
  setOpenPhone(true)
}
  return (
    <>
    <header>
        <div className={classes.header}>
      <NavLink to="/" className={classes.logo_link}><img src={logo} alt="logo" className={classes.logo}/></NavLink>
      { (forphone > 1000) ?(<nav>
        <NavLink to="/" className={classes.nav_link}>Home</NavLink>
        <NavLink to="/blog" className={classes.nav_link}>blog</NavLink>
        <div className={classes.button} onClick={() => setOpen(true)}>
         Contact Me
        </div>
      </nav>
      )
      
      :
      (<div className={classes.mobile_nav} onClick={handleMenuPhone}>
      </div>)}
    </div>
    </header>
    <FormDialog open={open} setOpen={setOpen} fullScreen={!resize}>
        <Form resize={resize}/>
    </FormDialog>
    <FormDialog open={openphone} setOpen={setOpenPhone} fullScreen={true}>
        <HeadPhone setOpen={setOpen} setOpenPhone={setOpenPhone}/>
    </FormDialog>
</>

    
  )
}

export default Header
